var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopilotEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0548 10.0693L16.8379 9.312C17.2681 8.896 17.9629 8.896 18.3931 9.312L19.1762 10.0693C19.6064 10.4853 19.6064 11.1573 19.1762 11.5733L18.3931 12.3307L16.0548 10.0693ZM15.2716 10.8267L9.5802 16.3307C9.48093 16.4267 9.42578 16.5547 9.42578 16.704V18.208C9.42578 18.5067 9.66844 18.7413 9.97728 18.7413H11.5325C11.6759 18.7413 11.8193 18.688 11.9185 18.5813L17.61 13.0773L15.2716 10.8267Z",
    fill: "#1777CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00805 10.3633L5.96818 12.8794C5.73928 13.4402 5.00679 13.4402 4.77789 12.8794L3.73802 10.3633L1.449 9.2202C0.938875 8.96139 0.938875 8.16341 1.449 7.91179L3.73802 6.76873L4.77789 4.25256C5.01333 3.69181 5.73928 3.69181 5.96818 4.25256L7.00805 6.76873L9.29707 7.91179C9.8072 8.17059 9.8072 8.96858 9.29707 9.2202L7.00805 10.3633ZM11.6123 5.69037L11.0956 4.43228L9.95108 3.86435C9.69601 3.73494 9.69601 3.33955 9.95108 3.21014L11.0956 2.64221L11.6123 1.37693C11.73 1.09656 12.0897 1.09656 12.2074 1.37693L12.7241 2.63502L13.8751 3.20295C14.1302 3.33236 14.1302 3.72776 13.8751 3.85716L12.7306 4.42509L12.2139 5.69037C12.0962 5.97074 11.73 5.97074 11.6123 5.69037Z",
    fill: "#1777CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotEdit);
export default __webpack_public_path__ + "static/media/copilot-edit.86a7b4e15e51e49010eee543168d04d6.svg";
export { ForwardRef as ReactComponent };